export const locale = {
    id: 'de-CH',
    prefix: '',
    mailDomain: 'ch',
};
